module.exports = __webpack_public_path__ + "img/13.be258c4a.jpg";